import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Col, Table, Row, List, Avatar } from "antd";
import { showColumnAction } from './UnitListTableColumn';
import "./UnitListTableWidget.css"
import { PicCenterOutlined } from '@ant-design/icons';
function UnitListTableWidget(props) {
  const [isBusy, setIsBusy] = useState(false);
  const { unitList, onUpdateAction, onDeleteAction, } = props;
  if (unitList === undefined) return <div />
  const columns = [
    {
      title: "ID",
      align: "center",
      dataIndex: "id"
    },
    {
      title: "Name",
      dataIndex: "name",
      width : '400px',
      align: "center",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
      },
    },
    {
      title: "Created At",
      align: "center",
      dataIndex: "add_timestamp",
      sorter: {
        compare: (a, b) => a.add_timestamp.localeCompare(b.add_timestamp),
      },
    },
    {
      title: "Updated At",
      align: "center",
      dataIndex: "update_timestamp",
      sorter: {
        compare: (a, b) => a.update_timestamp.localeCompare(b.update_timestamp),
      },
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "active",
      sorter: {
        compare: (a, b) => a.active - b.active,
      },
      render: (text, record) => {
        if (record.active === "1") {
          return <span className="active-btn">A</span>
        }
        else {
          return <span className="inactive-btn">I</span>
        }
      }
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => {
        return showColumnAction(text, record, onUpdateAction, onDeleteAction)
      },
    },
  ];
  const locationDataSource = unitList.map((info) => {
    return { ...info, key: info.id };
  });
  return (
    <div className="list-table">
      <Table
        pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50'] }}
        columns={columns}
        dataSource={locationDataSource}
      />
    </div>
  )
}

export default withRouter(UnitListTableWidget)
